export default ({ commit }) => {
	commit('SET_DISMISS_MIXED_OWNERSHIP', true);
};
